!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.unitInputs = this.querySelectorAll('input[name="size-guide-unit"]'), 
      this.table = this.querySelector("[data-table]"), this.table && (this.cells = this.table.querySelectorAll("td"), 
      this.unitHeader = this.table.querySelector("th"), this.cmToIn = .393701, this.storeInitialValues(), 
      this.addEventListeners());
    }
    storeInitialValues() {
      this.cells.forEach(t => {
        const e = t.textContent.trim(), i = parseFloat(e);
        !isNaN(i) && isFinite(e) && (t.dataset.cmValue = e);
      }), this.unitHeader && (this.originalUnitText = this.unitHeader.textContent.trim());
    }
    addEventListeners() {
      this.unitInputs.forEach(t => {
        t.addEventListener("change", this.handleUnitChange.bind(this));
      });
    }
    handleUnitChange(t) {
      const e = t.target.value;
      this.convertValues(e), this.updateUnitHeader(e);
    }
    convertValues(t) {
      this.cells.forEach(e => {
        if (e.dataset.cmValue) {
          const i = parseFloat(e.dataset.cmValue);
          if ("in" === t) {
            let t = (i * this.cmToIn).toFixed(1);
            t.endsWith(".0") && (t = t.slice(0, -2)), e.textContent = t;
          } else e.textContent = e.dataset.cmValue;
        }
      });
    }
    updateUnitHeader(t) {
      this.unitHeader && (this.unitHeader.textContent = "in" === t ? "Inches" : "CM");
    }
  }
  customElements.get("size-guide-table") || customElements.define("size-guide-table", t);
}();